import { render, staticRenderFns } from "./info-page.vue?vue&type=template&id=04d8c36d&"
import script from "./info-page.vue?vue&type=script&lang=ts&"
export * from "./info-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d8c36d')) {
      api.createRecord('04d8c36d', component.options)
    } else {
      api.reload('04d8c36d', component.options)
    }
    module.hot.accept("./info-page.vue?vue&type=template&id=04d8c36d&", function () {
      api.rerender('04d8c36d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/info-page/info-page.vue"
export default component.exports